import {
  FormContainer,
  Title,
  Subtitle,
  Label,
  Input,
  FileInput,
  CheckboxLabel,
  SubmitButton,
  NameAndPhoneContainer,
  InputContainer,
  CVContainer,
  ButtonContainer
} from './JoinTeam.style';
import { BiFolder } from 'react-icons/bi';

const JoinTeam = () => {
  return (
    <FormContainer>
      <Title>Sé parte de la familia Eupha</Title>
      <Subtitle>¡Te estamos esperando!</Subtitle>
      
      <NameAndPhoneContainer>
        <InputContainer>
          <Label>Nombre</Label>
          <Input type="text" placeholder="Nombre" />
        </InputContainer>

        <InputContainer>
          <Label>Teléfono</Label>
          <Input type="tel" placeholder="Teléfono" />
        </InputContainer>
      </NameAndPhoneContainer>
      
      <Label>Correo</Label>
      <Input type="email" placeholder="Correo electrónico" />
      
      <CVContainer>
      <Label>CV</Label>
      <FileInput><BiFolder/><p> Enviar PDF</p></FileInput>
      </CVContainer>

      <CheckboxLabel>
        <input type="checkbox" /> Acepto las condiciones de uso al enviar este formulario.
      </CheckboxLabel>
      
      <ButtonContainer>
      <SubmitButton>Enviar formulario</SubmitButton>
      </ButtonContainer>
    </FormContainer>
  );
};

export default JoinTeam;